import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

interface HealthResponse {
  status: 'ok' | 'degraded';
  version: string;
  uptimeSeconds: number;
  database: 'ok' | 'unavailable';
}

/** Polls `/v1/health` so the status bar can show a real API connection state. */
export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => apiFetch<HealthResponse>('/health'),
    refetchInterval: 15_000,
    retry: false,
  });
}
